import type { ProductFaq } from '../lib/types';

interface FaqsProps {
  items: ProductFaq[];
}

/**
 * Native <details>/<summary> accordion. Pure HTML — no JS state, no
 * libraries, and search engines index the answers because they're in the
 * DOM at render time. The JSON-LD that drives FAQ-rich-result eligibility
 * is emitted separately by the parent via <Seo jsonLd={...}>.
 */
export default function Faqs({ items }: FaqsProps) {
  if (!items || items.length === 0) return null;
  return (
    <div className="space-y-3">
      {items.map((f, i) => (
        <details
          key={i}
          className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-colors open:border-brand-200 open:bg-brand-50/30"
        >
          <summary className="flex cursor-pointer list-none items-center justify-between gap-3 p-5 text-base font-semibold text-slate-900 marker:content-none">
            <span>{f.q}</span>
            <span className="grid h-7 w-7 flex-shrink-0 place-items-center rounded-full bg-slate-100 text-lg font-medium text-brand-600 transition group-open:rotate-45 group-open:bg-brand-500 group-open:text-white">
              +
            </span>
          </summary>
          <p className="whitespace-pre-line px-5 pb-5 text-sm leading-relaxed text-slate-700">{f.a}</p>
        </details>
      ))}
    </div>
  );
}
